import { useGetTreeById } from '../../../reducers/trees_hooks'
import { nodeForId } from '../../utility/TreeHelpers'
import { useMemo } from 'react'
import { createIdMap } from '../../version_mapping/utility'
import { useParams } from 'infrastructure/routing'

function useRoutedTreeIds() {
  const { treeVersionNodeId } = useParams()
  const [treeId, versionId, nodeId] = treeVersionNodeId?.split(':') ?? []
  return {
    treeId,
    versionId,
    nodeId,
  }
}

export function useRoutedTree() {
  const { treeId, versionId } = useRoutedTreeIds()
  return useGetTreeById({ treeId, versionId })
}

export function useRoutedNode() {
  const { nodeId } = useRoutedTreeIds()
  const { tree } = useRoutedTree()
  return useMemo(() => {
    if (!nodeId || !tree) return tree
    return nodeForId(nodeId, tree)
  }, [nodeId, tree])
}

export function useRoutedTreeIdMap() {
  const { tree } = useRoutedTree()
  return useMemo(() => {
    if (!tree) return
    return createIdMap(tree)
  }, [tree])
}
